goog.provide('el8.appchart.visitNote.textlisteditor');

goog.require('el8.model.base');
goog.require('el8.uiwidget.listeditor');
goog.require('el8.appchart.visitNote.textlist');

/**
 * This is a listeditor augmented with a textlist, specifically a list of owned docs
 * that cannot be edited. The textlist always appears above the listeditor
 * in the visit note, so the sequences need to be massaged as such.
 */
el8.appchart.visitNote.textlisteditor = function(spec) {

    spec = spec || {};

    /* Create a textlist */
    this._textlist = new el8.appchart.visitNote.textlist(spec['textlistOpts']);

    /* Modify saveFn so that it accommodates the sequence modification */
    var that = this;
    var oldSaveFn = spec['saveFn'];
    var modifiedSaveFn = function(id, val, index, opts) {
        index = index + that._textlist.numEntries();
        oldSaveFn(id, val, index, opts);
    };
    spec['saveFn'] = modifiedSaveFn;

    /* Inherited constructor of listeditor */
    el8.uiwidget.listeditor.call(this, spec);

};
el8.appchart.visitNote.textlisteditor.inheritsFrom(el8.uiwidget.listeditor);

/**
 * Need to extend listeditor init() to init textlist too
 */
el8.appchart.visitNote.textlisteditor.prototype.init = function(var_args) {
    this._textlist.init();
    el8.uiwidget.listeditor.prototype.init.apply(this, arguments);
    return this;
};

/**
 * Need to extend addEntry method to support textlist support; note that the 
 * addEntry on listeditor takes into account the sequence bump of the textlist 
 * due to the modifiedSaveFn in the constructor above
 */
el8.appchart.visitNote.textlisteditor.prototype.addEntry = function(item, doHighlight) {
    var that = this;
    if (item.isDocumentOwnedBy()) {
        this._textlist.addEntry(item, doHighlight);
    } else {
        el8.uiwidget.listeditor.prototype.addEntry.apply(this, arguments);
    }
};
/**
 * Need to add method to removeOwnedDoc
 */
el8.appchart.visitNote.textlisteditor.prototype.removeOwnedDoc = function(docId) {
    this._textlist.removeOwnedDoc(docId);
};

/**
 * Method to return # of entries in list already, including textlist entries.
 *
 * Intentionally does not over-ride the existing "numEntries" method inherited from 
 * listeditor because that is needed to track the # of entries in the listeditor only.
 */
el8.appchart.visitNote.textlisteditor.prototype.totalNumEntries = function() {
    return this.numEntries() + this._textlist.numEntries();
};


